import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "@store/baseQuery";

export interface Subscription {
    id: number;
    status:
    | "trial"
    | "active"
    | "past_due"
    | "pending_change"
    | "pending_cancellation"
    | "suspended"
    | "trial_expired"
    | "cancelled"
    | "archived";
    started_at: string;
    expires_at: string | null;
    founder_offer_status: "active" | "completed" | "forfeited" | null;
}

export interface Plan {
    id: number;
    name: string;
    plan_type: "trial" | "starter" | "growth" | "enterprise";
    credits: string;
    duration_days: number | null;
}

export interface CreditBalance {
    total_allocated: string;
    total_used: string;
    remaining: string;
    usage_percentage: string;
}

export interface SubscriptionStatusResponse {
    subscription: Subscription;
    plan: Plan;
    credits: CreditBalance;
    data?: any;
}

export interface CreditTransaction {
    id: number;
    transaction_type: "allocation" | "deduction" | "refund";
    amount: string;
    source: "demolab" | "system";
    description: string;
    created_at: string;
}

export const subscriptionApi = createApi({
    reducerPath: "subscriptionApi",
    baseQuery: customBaseQuery,
    tagTypes: ["Subscription", "Credits"],
    endpoints: (builder) => ({
        getSubscriptionStatus: builder.query<
            SubscriptionStatusResponse,
            void
        >({
            query: () => ({
                url: "/subscriptions/status/",
                method: "GET",
            }),
            providesTags: ["Subscription"],
        }),

        getCreditsBalance: builder.query<CreditBalance, void>({
            query: () => ({
                url: "/subscriptions/credits/balance/",
                method: "GET",
            }),
            providesTags: ["Credits"],
        }),

        getCreditTransactions: builder.query<CreditTransaction[], void>({
            query: () => ({
                url: "/subscriptions/credits/transactions/",
                method: "GET",
            }),
            providesTags: ["Credits"],
        }),
    }),
});

export const {
    useGetSubscriptionStatusQuery,
    useLazyGetCreditsBalanceQuery,
    useGetCreditTransactionsQuery,
} = subscriptionApi;